module.exports = __webpack_public_path__ + "media/images/sidebar-2-4837ec1a20a7f89a4cc2d7f5f9553f7d.jpg";